module.exports = __webpack_public_path__ + "img/1526570232.d8db44cb.jpg";